import { all, call, put, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* post(action) {
    const { auditSubmission } = action.payload;
    try {
        const { data } = yield call(
            http.authorized.post,
            config.api.paths.auditSubmissions,
            auditSubmission
        );
        yield put(actionCreators.postSuccess(data));
    } catch (error) {
        console.error(error);
        logToSentry("On audit submissions post:", { error });
        yield put(actionCreators.postFailure(error));
    }
}

export default function* () {
    yield all([takeLatest(actionTypes.AUDIT_SUBMISSIONS_POST_REQUEST, post)]);
}
